var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9441 12.75C11.5823 15.1556 9.50652 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C9.50652 7 11.5823 8.84437 11.9441 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12V15C22.75 15.4142 22.4142 15.75 22 15.75C21.5858 15.75 21.25 15.4142 21.25 15V12.75H18.75V14C18.75 14.4142 18.4142 14.75 18 14.75C17.5858 14.75 17.25 14.4142 17.25 14V12.75H11.9441ZM7 14.5C8.38071 14.5 9.5 13.3807 9.5 12C9.5 10.6193 8.38071 9.5 7 9.5C5.61929 9.5 4.5 10.6193 4.5 12C4.5 13.3807 5.61929 14.5 7 14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAlt2);
export default __webpack_public_path__ + "static/media/key-alt-2.f9af44edf7ae749fedc92fc0818c180b.svg";
export { ForwardRef as ReactComponent };